import { Injectable, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PaymentProcessingComponent } from '../components/payment-processing/payment-processing.component';
import { Observable, from, map, take, tap } from 'rxjs';
import { OrderConfirmationComponent } from '../components/order-confirmation/order-confirmation.component';
import { Order } from '../api/contracts/order';

@Injectable({
  providedIn: 'root',
})
export class FullscreenModalService {
  constructor(private readonly modalCtrl: ModalController) {}

  private presentModal(
    component: any,
    inputData?: Record<string, any>
  ): Observable<AppModal> {
    return from(
      this.modalCtrl.create({
        component: component,
        componentProps: inputData,
      })
    ).pipe(
      tap((modal) => modal.present()),
      map((ionicModal) => new AppModal(ionicModal))
    );
  }

  dismiss<T>(data?: T) {
    return this.modalCtrl.dismiss(data);
  }

  getTop() {
    return this.modalCtrl.getTop();
  }

  showPaymentProcessing(): Observable<AppModal> {
    return this.presentModal(PaymentProcessingComponent);
  }

  showOrderConfirmation(order: Order): Observable<AppModal> {
    return this.presentModal(OrderConfirmationComponent, {
      order,
    });
  }
}

class AppModal {
  constructor(private readonly ionicModal: HTMLIonModalElement) {}

  dismissWhen<T>(stream: Observable<T>): void {
    stream.pipe(take(1)).subscribe((data?: T) => {
      this.ionicModal.dismiss(data);
    });
  }

  onDismiss<T>(): Observable<T> {
    return from(this.ionicModal.onDidDismiss()).pipe(
      map((value) => value.data as T)
    );
  }

  dismiss<T>(data?: T): Observable<boolean> {
    return from(this.ionicModal.dismiss(data));
  }
}
